import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FlowConfig } from 'projects/borrower-app/src/app/models/wizard/config/flow-config.model';
import { WizardFlowServiceBase } from 'projects/borrower-app/src/app/services/wizard/wizard-flow-service.base';
import { ChangeDetectorRef } from '@angular/core';



@Component({
  selector: 'flow-list-dialog',
  templateUrl: 'flow-list-dialog.component.html',
  standalone: false
})

export class FlowListDialogComponent implements OnInit {

  flows: FlowConfig[] = [];
  loading: boolean = true;

  constructor(public activeModal: NgbActiveModal,private readonly _wizardFlowService: WizardFlowServiceBase, 
    private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.loadFlows();
  }

  private loadFlows(): void {

    const observable = this._wizardFlowService.getFlowConfigs();

    if (observable) {
      observable.subscribe({
        next: (results) => {
          this.flows = results;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.loading = false;
          this.cdr.detectChanges();
        }
      });
    } else {
      this.loading = false;
    }
  }

  onFlowClicked = (flow: FlowConfig) => {
    this.activeModal.close();
    this._wizardFlowService.navigateToFlow(flow.flowGuid);
  }

  onDeleteFlowClicked = (flow: FlowConfig) => {
    this._wizardFlowService.deleteFlowConfig(flow.flowGuid)
      .subscribe({
        next: () => {
          const index = this.flows.findIndex(f => f.flowGuid === flow.flowGuid);
          if (index >= 0) {
            this.flows.splice(index, 1);
          }
        },
        error: () => {
        }
      });
  }
}
